<template>
  <b-form @submit.prevent="evOnSubmit">
    <b-row>
      <b-col>
        <h6 class="text-center worksansr">
          Informe o código recebido no e-mail:
        </h6>
        <v-text-field
          :loading="loading"
          :disabled="step != 0"
          dense
          outlined
          label="Código"
          placeholder="********"
          hide-details
          ref="autofocus"
          v-model="code"
        />
      </b-col>
    </b-row>
    <errors-messages :errors="errors" class="error-margin" />
    <success-message :message="timeoutMessage" />
    <b-row v-if="step == 0">
      <b-col class="pt-0">
        <v-btn type="submit" class="btn-acess btn-block" :disabled="loading">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "VERIFICANDO" : "VALIDAR" }}
        </v-btn>
      </b-col>
    </b-row>
    <b-row v-if="step == 0" align-h="between">
      <b-col cols="auto">
        <v-btn
          text
          class="text-thirteen"
          :disabled="loading"
          @click="$emit('request-code')"
        >
          <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
        </v-btn>
      </b-col>
      <b-col cols="auto">
        <v-btn
          text
          class="text-thirteen"
          :disabled="loading"
          @click="$router.push({ name: 'sign-in' })"
        >
          LOGIN
        </v-btn>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import api from "../../services/api";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import SuccessMessage from "../Components/SuccessMessage.vue";
export default {
  name: "RecoverWithCode",
  components: { ErrorsMessages, SuccessMessage },
  props: {
    timeoutMessage: String,
  },
  data() {
    return {
      errors: [],
      loading: false,

      step: 0,
      code: "",
    };
  },
  mounted() {
    this.$refs.autofocus.focus();
  },
  methods: {
    async evOnSubmit() {
      try {
        this.loading = true;

        let params = { code: this.code };
        let response = await api.get(
          "/rest-home/user/new-password/receive-token",
          { params }
        );
        let { error, errors, email, token } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.step = 1;
          this.$emit("token-received", email, token);
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
